import classnames from 'classnames'

export default function Switch({
  on,
  name,
  color,
  onLabel = 'Yes',
  offLabel = 'No',
  onToggle,
  ...rest
}) {
  return (
    <button
      className={classnames('switch flex alignCenter', { on })}
      onClick={() => onToggle(name, !on)}
      {...rest}
    >
      <div className='toggle'>
        <div className='toggleHandle' />
      </div>
      <p className='label'>{on ? onLabel : offLabel}</p>

      <style jsx>{`
        .switch {
          min-width: 89px;
          background: 0;
          border: 0;

          &.on {
            .toggleHandle {
              transform: translateX(26px);
            }
          }
        }

        .toggle {
          position: relative;
          width: 48px;
          height: 22px;
          border-radius: 11px;
          border: 2px solid var(--secondary-button-bg);
          background-color: var(--secondary-button-bg);
          transition: background-color 0.3s, border-color 0.3s;

          .toggleHandle {
            position: absolute;
            top: 0;
            left: 0;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #fff;
            transition: transform 0.15s;
          }
        }

        .label {
          flex: 1;
          color: var(--secondary-text-color);
          text-align: right;
          font-weight: 700;
          font-size: 1.6rem;
        }

        @media (max-width: 1024px) {
          .switch {
            min-width: 6.5rem;

            &.on {
              .toggleHandle {
                transform: translateX(18px);
              }
            }
          }

          .toggle {
            width: 38px;
            height: 20px;

            .toggleHandle {
              width: 16px;
              height: 16px;
            }
          }

          .label {
            font-size: 1.2rem;
          }
        }
      `}</style>

      <style jsx>{`
        .switch {
          &.on {
            .toggle {
              border-color: ${color === 'success'
                ? 'var(--success-color)'
                : color === 'alert'
                ? 'var(--alert-color)'
                : 'var(--primary-color)'};

              background-color: ${color === 'success'
                ? 'var(--success-color)'
                : color === 'alert'
                ? 'var(--alert-color)'
                : 'var(--primary-color)'};
            }

            .label {
              color: ${color === 'success'
                ? 'var(--success-color)'
                : color === 'alert'
                ? 'var(--alert-color)'
                : 'var(--primary-color)'};
            }
          }
        }
      `}</style>
    </button>
  )
}
